import { hotComments } from "@/mocks/opinion";

function ratio(agree: number, oppose: number) {
  const total = agree + oppose;
  return Math.round((agree / total) * 100);
}

export default function HotCommentSection() {
  return (
    <section id="comments" className="bg-background-100/70">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-2xl">
          <p className="inline-flex items-center gap-2 text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600">
            <span className="h-px w-6 bg-primary-500"></span> Hot Comments
          </p>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-black text-foreground-950">热门热评</h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
            编辑部从海量讨论里挑出的代表性话题，标注了点赞分布与主流风向，配几段最真实的网友原声。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
          {hotComments.map((topic) => {
            const agreePct = ratio(topic.agree, topic.oppose);
            return (
              <article
                key={topic.id}
                className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6 transition-colors hover:border-secondary-300"
              >
                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-900">
                    <i className="ri-price-tag-3-line" aria-hidden="true"></i>
                    {topic.category}
                  </span>
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
                    <i className="ri-windy-line" aria-hidden="true"></i>
                    风向 · {topic.wind}
                  </span>
                </div>

                <h3 className="mt-4 font-heading text-lg md:text-xl font-bold leading-snug text-foreground-950">
                  {topic.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-foreground-700">{topic.summary}</p>

                {/* agree bar */}
                <div className="mt-5">
                  <div className="flex items-center justify-between text-xs text-foreground-600">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-thumb-up-line text-primary-600" aria-hidden="true"></i>
                      赞同 {(topic.agree / 1000).toFixed(1)}k
                    </span>
                    <span className="inline-flex items-center gap-1">
                      反对 {(topic.oppose / 1000).toFixed(1)}k
                      <i className="ri-thumb-down-line text-accent-700" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div className="mt-2 h-2 overflow-hidden rounded-full bg-background-200">
                    <div className="h-full rounded-full bg-primary-500" style={{ width: `${agreePct}%` }}></div>
                  </div>
                </div>

                <ul className="mt-5 space-y-2.5 border-t border-background-200 pt-4">
                  {topic.comments.map((c, i) => (
                    <li key={i} className="flex items-start gap-2.5 text-sm leading-relaxed text-foreground-800">
                      <i className="ri-chat-quote-line mt-0.5 shrink-0 text-base text-secondary-500" aria-hidden="true"></i>
                      <span>{c}</span>
                    </li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}